import gql from 'graphql-tag';

const mutations = {

  /**
   * 1
   */
  VERIFY_TOWERS: gql`
  mutation verifyListOfTowers {
    verifyListOfTowers
  }`,

  /**
   * 2
   */
  VERIFY_ACTIONS: gql`
  mutation verifyActionsByTower($ethId: Int!) {
    verifyActionsByTower(ethId: $ethId) {
      total
      build
      destroy
      fixedBuild
      fixedDestroy
    }
  }`,

  /**
   * Add recipients
   */
  ADD_RECIPIENTS: gql`
  mutation addRecipients($input: [RecipientInputType!]!) {
    addRecipients(input: $input) {
      id
      name
      email
      counter
      createdAt
      updatedAt
    }
  }`,

  /**
   * A
   */
  SEND_ALL: gql`
  mutation sendAll {
    sendAll
  }`,
};

export default mutations;
